<script setup>
// Links sibling pages that do one job together (owner order 2026-10-10:
// fewer sidebar entries, same pages). Callers pass only the tabs the viewer
// may open; with fewer than two there is nothing to switch, so nothing shows.
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  // [{ name: routeName, label: translatedText }]
  tabs: { type: Array, required: true },
});

const route = useRoute();
const visible = computed(() => props.tabs.length > 1);
</script>

<template>
  <nav
    v-if="visible"
    class="flex flex-wrap gap-1 mb-4 border-b border-n-weak"
    role="tablist"
  >
    <router-link
      v-for="tab in tabs"
      :key="tab.name"
      :to="{ name: tab.name, params: { accountId: route.params.accountId } }"
      role="tab"
      :aria-selected="route.name === tab.name"
      class="px-3 py-2 -mb-px text-sm border-b-2"
      :class="
        route.name === tab.name
          ? 'border-n-brand text-n-slate-12 font-medium'
          : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
      "
    >
      {{ tab.label }}
    </router-link>
  </nav>
</template>
